import { render, staticRenderFns } from "./AddCandidateBtnModalMobile.vue?vue&type=template&id=8bc4f178&scoped=true"
import script from "./AddCandidateBtnModalMobile.vue?vue&type=script&lang=js"
export * from "./AddCandidateBtnModalMobile.vue?vue&type=script&lang=js"
import style0 from "./AddCandidateBtnModalMobile.vue?vue&type=style&index=0&id=8bc4f178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc4f178",
  null
  
)

export default component.exports